import { render, staticRenderFns } from "./Popu9001.vue?vue&type=template&id=25f2b930&scoped=true&"
import script from "./Popu9001.vue?vue&type=script&lang=js&"
export * from "./Popu9001.vue?vue&type=script&lang=js&"
import style0 from "./Popu9001.vue?vue&type=style&index=0&id=25f2b930&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "25f2b930",
  null
  
)

export default component.exports